import { css, cva } from '@/styled-system/css';

// NOTE: This value must stay in sync with LEFT_NAV_WIDTH exported from constants/index.ts
// We define it here as a literal because Panda CSS cannot resolve imported constants in styles
const LEFT_NAV_WIDTH = 296;

export const appLayoutContainerRecipe = cva({
  base: {
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    '& *, & *::before, & *::after': {
      boxSizing: 'border-box',
    },
  },
  variants: {
    isLeftNav: {
      true: {
        backgroundColor: 'bg.neutral',
      },
      false: {},
    },
  },
});

export const bodyContainerRecipe = cva({
  base: {
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
  },
  variants: {
    isLeftNav: {
      true: {},
      false: {},
    },
    hideNavigation: {
      true: {},
      false: {},
    },
  },
  compoundVariants: [
    {
      isLeftNav: true,
      hideNavigation: false,
      css: {
        xl: {
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
          justifyContent: 'flex-start',
          alignItems: 'center',
          marginLeft: `${LEFT_NAV_WIDTH}px`,
          overflowY: 'auto',
        },
      },
    },
    {
      isLeftNav: true,
      hideNavigation: true,
      css: {
        xl: {
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
          justifyContent: 'flex-start',
          alignItems: 'center',
          marginLeft: 0,
          overflowY: 'auto',
        },
      },
    },
  ],
  defaultVariants: {
    isLeftNav: false,
    hideNavigation: false,
  },
});

export const layoutContainerRecipe = cva({
  base: {
    display: 'flex',
    flex: 1,
    width: '100%',
    height: '100%',
    flexDirection: 'column',
    zIndex: 1000,
  },
  variants: {
    isLeftNav: {
      true: {
        xl: {
          flexDirection: 'row',
        },
      },
      false: {
        xl: {
          flexDirection: 'column',
        },
      },
    },
  },
  defaultVariants: {
    isLeftNav: false,
  },
});

export const verticalNavigationContainerRecipe = cva({
  base: {
    position: 'fixed',
    height: '100%',
    borderRadius: '0px 0px 0px {spacing.400}',
    borderRight: '1px solid {colors.border.muted}',
    backgroundColor: 'bg.neutral',
  },
  variants: {
    hideNavigation: {
      true: {
        width: 0,
      },
      false: {
        width: `${LEFT_NAV_WIDTH}px`,
      },
    },
  },
  defaultVariants: {
    hideNavigation: false,
  },
});

export const footerContainerStyles = css.raw({
  backgroundColor: 'bg.neutral',
  marginLeft: `${LEFT_NAV_WIDTH}px`,
});
